var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.00001V11M9.25 4.5H5.8C4.11984 4.5 3.27976 4.5 2.63803 4.82698C2.07354 5.1146 1.6146 5.57355 1.32698 6.13803C0.999998 6.77977 0.999999 7.61985 1 9.30001L1 10.5C1 11.4319 1 11.8978 1.15224 12.2654C1.35523 12.7554 1.74458 13.1448 2.23463 13.3478C2.60218 13.5 3.06812 13.5 4 13.5V17.75C4 17.9822 4 18.0983 4.00963 18.196C4.10316 19.1456 4.85441 19.8968 5.80397 19.9904C5.90175 20 6.01783 20 6.25 20C6.48217 20 6.59826 20 6.69604 19.9904C7.64559 19.8968 8.39685 19.1456 8.49037 18.196C8.5 18.0983 8.5 17.9822 8.5 17.75V13.5H9.25C11.0164 13.5 13.1772 14.4469 14.8443 15.3556C15.8168 15.8858 16.3031 16.1509 16.6216 16.1119C16.9169 16.0757 17.1402 15.9431 17.3133 15.7011C17.5 15.4402 17.5 14.918 17.5 13.8737V4.12629C17.5 3.082 17.5 2.55985 17.3133 2.29889C17.1402 2.0569 16.9169 1.9243 16.6216 1.88813C16.3031 1.84912 15.8168 2.1142 14.8443 2.64436C13.1772 3.55312 11.0164 4.5 9.25 4.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.e2b096aa132211320728a5f8a49a47a5.svg";
export { ForwardRef as ReactComponent };